// extracted by mini-css-extract-plugin
module.exports = {"root":"PrintMultiPreviewLayout_root__3IpPN","colClientInfo":"PrintMultiPreviewLayout_colClientInfo__1LsPj"};